import { motion } from 'framer-motion'

export default function Logo({ className = 'h-10 w-10' }) {
  return (
    <motion.svg
      viewBox="0 0 64 64"
      className={className}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8b5cf6" />
          <stop offset="50%" stopColor="#7c3aed" />
          <stop offset="100%" stopColor="#06b6d4" />
        </linearGradient>
        <filter id="glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      
      {/* Background */}
      <rect width="64" height="64" rx="14" fill="#0f172a" />
      
      {/* Signal waves */}
      <g transform="translate(8, 16)" filter="url(#glow)">
        <motion.path
          d="M0 16 Q12 4 24 16 T48 16"
          stroke="url(#logoGradient)"
          strokeWidth="3"
          fill="none"
          strokeLinecap="round"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 1, delay: 0.2 }}
        />
        <motion.path
          d="M0 24 Q12 12 24 24 T48 24"
          stroke="url(#logoGradient)"
          strokeWidth="2.5"
          fill="none"
          strokeLinecap="round"
          opacity="0.7"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 1, delay: 0.4 }}
        />
        <motion.path
          d="M0 32 Q12 20 24 32 T48 32"
          stroke="url(#logoGradient)"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          opacity="0.4"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
        />
      </g>
      
      {/* Accent dot */}
      <motion.circle
        cx="52"
        cy="12"
        r="4"
        fill="#06b6d4"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.3, delay: 0.8, type: 'spring' }}
      />
    </motion.svg>
  )
}
